import { Component } from '../component';
import type { TextExpanderEvents } from '@otto-ec/global-pattern';

export class GenericFootnotes extends Component {
    public variationChanged() {
        const genericFootnotesElement = document.querySelector<HTMLElement>('.js_rc_generic-footnotes');
        if (genericFootnotesElement) {
            window.o_global.events<TextExpanderEvents>().emit('assets.textExpander.init', '.js_rc_generic-footnotes');
        }
    }
}
